import { types, flow } from 'mobx-state-tree';
import API from '../../api/parking';
import requsetErrorMessage from '../../helpers/requsetErrorMessage';
import ParkingField from './ParkingField';

const ParkingFields = types
    .model('ParkingFields', {
        fields: types.array(ParkingField),
        selectedField: types.maybeNull(types.reference(ParkingField)),
        error: types.union(
            types.optional(types.string, ''),
            types.optional(types.array(types.string), []),
        ),
        dataLoaded: types.optional(types.boolean, false),
    })
    .actions((self) => ({
        getFields: flow(function* getFields() {
            self.error = '';
            try {
                const res = yield API.getFields();
                self.fields = res.data;
                self.dataLoaded = true;
            } catch (error) {
                self.dataLoaded = true;
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),
        getField: flow(function* getField(id) {
            self.error = '';
            try {
                const res = yield API.getField(id);
                const existing = self.fields.find((f) => f.id === res.data.id);
                if (existing) {
                    existing.editField(res.data);
                } else {
                    self.fields.push(res.data);
                }
                self.selectedField = res.data.id;
                self.dataLoaded = true;
            } catch (error) {
                self.dataLoaded = true;
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),
        selectField(id) {
            self.selectedField = id;
        },
        editField: flow(function* editField(edited) {
            try {
                const res = yield API.editField(self.selectedField.id, edited);
                self.selectedField.editField(res.data);
            } catch (error) {
                throw error;
            }
        }),
        addSperrDate: flow(function* addSperrDate(data) {
            try {
                const res = yield API.addSperrDate(self.selectedField.id, data);
                self.selectedField.addSperrDateLocal(res.data);
            } catch (error) {
                throw error;
            }
        }),
        removeSperrDate: flow(function* removeSperrDate(sperrId) {
            try {
                yield API.removeSperrDate(self.selectedField.id, sperrId);
                self.selectedField.removeSperrDateLocal(sperrId);
            } catch (error) {
                self.error = requsetErrorMessage(error && error.message ? error.message : error);
            }
        }),
        setDataLoaded() {
            self.dataLoaded = true;
        },
    }));

export default ParkingFields;
